
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.781 4.157a1 1 0 00-1.732-1L8.88 15.573a3.5 3.5 0 10.146 3.746l.004-.007 8.75-15.155zM7.299 18.312a1.5 1.5 0 11-2.598-1.5 1.5 1.5 0 012.598 1.5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.219 4.157a1 1 0 111.732-1l7.168 12.416a3.5 3.5 0 11-.15 3.74l-.008-.014L6.22 4.157zm10.485 14.16a1.5 1.5 0 10-.008-.013l.005.008.003.006z"}})])
          )
        }
      }
    